// extracted by mini-css-extract-plugin
export default {"button":"UpdateForm_button__V-AlD"};